
import React, { useEffect, useState, useCallback } from 'react'
import CardTable from "components/CardTable/CardTable";
import { useSearch } from "hooks/useSearch";
import { TableInputs } from "components/CardTable/TableInputs";
import { useSelector, useDispatch } from "react-redux";
import { useValidateReload } from "hooks/useValidateReload";
import { setSnackbar } from "redux/actions/search/searchActions";

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { handleSupportExpensesInputsAction, getSupportExpensesAction } from "redux/actions/supportExpenses/supportExpensesActions";
import { columns } from './columns';
const tableKey = "supportExpenses";
const loadings = ["loadingSupportExpenses", "loadingModSupportExpenses"];

export const SupportExpensesView = () => {
  const dispatch = useDispatch();
  const { ExpensesPeriod, date, company } = useSelector(({ supportExpenses }) => supportExpenses);
  const { companies } = useSelector(state => state.companies) 
  const { buildCompLoadings, buildTableConfig } = useSearch();
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const [mapPeriodExpenses, setMapPeriodExpenses] = useState([])
  const handleSubmit = useCallback((e) => {
    e.preventDefault()
    let month = null
    let year = null
    if (date) {
      month = date.substr(-2)
      year = date.substr(0, 4)
    }
    if (!company?.id) {
      dispatch(setSnackbar("Falta Compañía"));
      return
    }
    dispatch(getSupportExpensesAction(month, year, company?.id))
  }, [date, company]);

  useValidateReload(loadings);

  useEffect(() => {
    buildCompLoadings(loadings);
    if (!configTables[tableKey]) buildTableConfig(tableKey);
  }, []);

  useEffect(() => {
    const periods = Array.isArray(ExpensesPeriod) ? ExpensesPeriod : []
    setMapPeriodExpenses(periods.map((period) => ({ ...period, company: companies[period?.idCompany]?.name })))
  }, [ExpensesPeriod, companies])

  return (
    <>
      <CardTable
        data={mapPeriodExpenses}
        columns={columns}
        hasHeader
        blockBtn
        title={"Soporte Periodos Gastos"}
        icon={<CalendarTodayIcon />}
        isLoading={isLoadingComp?.loadingSupportExpenses}
        tableContent={
          <TableInputs
            reducer="supportExpenses"
            date
            monthType
            companies
            dispatchAction={handleSupportExpensesInputsAction}
            submitAction={handleSubmit}
          />
        }
        tableKey={tableKey}
      />
    </>
  );
};